<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-7">
            <table>
              <tr>
                <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a>
                </td>
                <td>
                  <flat-pickr @on-change="onDateChanged" :config="exportConfig" class="font-13" v-model="exportDates"
                    name="export_date_start"></flat-pickr>
                </td>
                <td>
                  <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                      <option :value="''">Please select</option>
                      <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-sm-5 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control"
                    placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(link)="data">
            {{ data.item.link }}
          </template>
          <!-- <template v-slot:cell(actions)="data">
            <b-button v-if="getRoleId != '33'" size="sm"
              @click="editCoach('/frontendSetting/groupFitness/edit/' + data.item.id)" class="btn-table primary mr-1">
              <i class="far fa-edit"></i> Edit
            </b-button>
            <b-button v-if="getRoleId != '33'" size="sm" v-on:click="deleteGF(data.item.id)" class="btn-table danger">
              <i class="fas fa-times"></i> Delete
            </b-button>
          </template> -->
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage" :total-pages="totalPage"
          @page-changed="pageOneChanged" prev-text="Prev" next-text="Next" />
      </div>
    </div>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="40" alt="">
        <br>
        <div class="title-loading color-white">Please wait...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'

export default {
  name: 'frontend_groupfitness',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      fields: [
        {
          key: 'period',
          label: 'Period',
          sortable: false
        },
        {
          key: 'branch',
          label: 'Club',
          sortable: false
        },
        {
          key: 'member_id',
          label: 'Member ID',
          sortable: false
        },
        {
          key: 'member_name',
          label: 'Member Name',
          sortable: false
        },
        {
          key: 'membership',
          label: 'Membership',
          sortable: false
        },
        {
          key: 'membership_status',
          label: 'Membership Status',
          sortable: false
        },
        {
          key: 'monthly_price',
          label: 'Monthly Price',
          sortable: false,
          formatter: value => {
            return value.toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })
          }
        },
        {
          key: 'start_membership',
          label: 'Start Membership',
          sortable: false
        },
        {
          key: 'NDP',
          label: 'NDP',
          sortable: false
        },
      ],
      items: [],
      sortType: 'desc',
      sortBy: 'id',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      branch_id: '',
      dataBranch: [],
      getRoleId: Auth.Session.get().paradigm_role,
      exportConfig: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d F Y",
        // onChange: this.onChange
      },
      exportDates: moment(new Date()).format('YYYY-MM-DD')
    }
  },
  computed: {
    name() {
      return this.$route.name
    }
  },
  methods: {
    exportReport() {
      this.loadingActive = true
      let url = 'crm/v1/export/report/motto?start_date=' + this.exportDates

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Motto Report ' + moment(this.exportDates).format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    onDateChanged(date) {
      this.exportDates = moment(date[0]).format('YYYY-MM-DD')
      this.fetchData()
    },
    sortingChanged(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    changeBranch(event) {
      console.log(event)
      this.fetchData()
    },
    enterClicked(searchEvent) {
      this.fetchData()
    },
    getBadge(status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount(items) {
      return items.length
    },
    openPage(event) {
      this.$router.push(event)
    },
    editCoach(event) {
      this.$router.push(event)
    },
    showModal(id) {
      this.$refs[id].show()
    },
    deleteGF(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('fitness/v1/frontend_groupfitness/'.concat(event)).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    parseImg(value) {
      return Auth.apiUrl + 'fitness/v1/img/frontend/groupfitness/' + value
    },
    fetchData() {
      this.loadingActive = true
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      this.branch_id = this.branch_id == null ? '' : this.branch_id
      axios.get('crm/v1/report/autopay_motto?category=MOTTO&page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + '&start_date=' + this.exportDates + '&branch_id=' + this.branch_id).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        // console.log('test', response.data.data.rows)
        this.loadingActive = false
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style></style>
